/**
    vignette
 */

import vertexShader from './Ortho.vert.glsl';
import fragmentShader from './VignetteShader.frag.glsl';
import {
  ShaderWithUniforms,
  VignetteShaderUniforms,
} from '../../types/shader.types';

export const VignetteShader: ShaderWithUniforms<VignetteShaderUniforms> = {
  uniforms: {
    tDiffuse: {value: null},
    amount: {
      value: 0.1,
    },
    brightness: {
      value: 0,
    },
  },
  vertexShader: vertexShader,
  fragmentShader: fragmentShader,
};
